export class EnumHelper {
    public static getEnumKeyByValue<T>(enumObj: Record<string, string>, value: T): string | undefined {
        return Object.keys(enumObj).find((key) => enumObj[key] === value);
    }
}
